import React from "react";
import { Wrapper, Paragraph } from "./styles/form-steps-styles";

const ReviewAlreadyLeft = () => (
  <Wrapper data-test-id="review-already-left">
    <Paragraph
      welcome
      className="animated fadeIn delay-1"
      center
      reviewLeft
      data-test-id="review-already-left-p-1"
    >
      You’ve already left a review for your recruiter.
    </Paragraph>
    <Paragraph
      className="animated fadeIn delay-2"
      center
      reviewLeft
      data-test-id="review-already-left-p-2"
    >
      Thank you
    </Paragraph>
  </Wrapper>
);

export default ReviewAlreadyLeft;
